import { DEFAULT_NUM_DECIMALS_ROUNDING_ON_REPLACE } from './constants'
import {
  PartialPointManipulationConfig,
  PointAxisManipulationConfig,
  PointManipulationConfig,
} from './types'

export const DEFAULT_INPUT_DECIMAL_SCALE = 2

const createDefaultAxisConfig = (): PointAxisManipulationConfig => ({
  roundOnReplace: true,
  defaultRoundNumDecimalsOnReplace: DEFAULT_INPUT_DECIMAL_SCALE,
  disabled: false,
  hidden: false,
})

export const createDefaultPointManipulationConfig = (
  overrides?: PartialPointManipulationConfig,
): PointManipulationConfig => ({
  x: { ...createDefaultAxisConfig(), ...overrides?.x },
  y: { ...createDefaultAxisConfig(), ...overrides?.y },
  z: { ...createDefaultAxisConfig(), roundOnReplace: false, ...overrides?.z },
})

export const createHighPrecisionPointManipulationConfig = (
  overrides?: PartialPointManipulationConfig,
): PointManipulationConfig =>
  createDefaultPointManipulationConfig({
    x: {
      roundOnReplace: true,
      defaultRoundNumDecimalsOnReplace: DEFAULT_NUM_DECIMALS_ROUNDING_ON_REPLACE,
    },
    y: {
      roundOnReplace: true,
      defaultRoundNumDecimalsOnReplace: DEFAULT_NUM_DECIMALS_ROUNDING_ON_REPLACE,
    },
    z: {
      roundOnReplace: true,
      defaultRoundNumDecimalsOnReplace: DEFAULT_NUM_DECIMALS_ROUNDING_ON_REPLACE,
    },
    ...overrides,
  })

export const createUnlimitedPrecisionPointManipulationConfig = (
  overrides?: PartialPointManipulationConfig,
): PointManipulationConfig =>
  createDefaultPointManipulationConfig({
    x: { roundOnReplace: false },
    y: { roundOnReplace: false },
    z: { roundOnReplace: false },
    ...overrides,
  })

export const createReadOnlyPointManipulationConfig = (
  overrides?: PartialPointManipulationConfig,
): PointManipulationConfig =>
  createDefaultPointManipulationConfig({
    x: { disabled: true },
    y: { disabled: true },
    z: { disabled: true },
    ...overrides,
  })

export const createDefaultXYPointManipulationConfig = (
  overrides?: PartialPointManipulationConfig,
): PointManipulationConfig =>
  createDefaultPointManipulationConfig({
    x: { roundOnReplace: true, defaultRoundNumDecimalsOnReplace: DEFAULT_INPUT_DECIMAL_SCALE },
    y: { roundOnReplace: true, defaultRoundNumDecimalsOnReplace: DEFAULT_INPUT_DECIMAL_SCALE },
    z: { roundOnReplace: false },
    ...overrides,
  })
